module.exports = __webpack_public_path__ + "static/media/dashboard.b4b1f7f3.jpg";